import React from 'react'
import PropTypes from 'prop-types'

import logo from '../../assets/logo-jellyfish-color-standard.png'
// import mark from '../../assets/mark-jellyfish-v2-color.png'

const Logo = () =>
  <a href="/" className="jellyfish-logo"><img className="img-fluid" src={logo} alt="logo" height="22" width="108" /></a>

Logo.defaultProps = {
  height: 108,
  width: 22,
}

Logo.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/common/Logo.jsx